<ul class="list-no-default-spacing" ngClass="{{ ulClass }}">
  @for (listItem of list; track listItem) {
    <li ngClass="{{ liClass }}">
      <a
        *wlGenericLink="listItem; extras: { queryParamsHandling: 'preserve' }"
      ></a>
    </li>
  }
</ul>
